import React, {useState} from 'react'
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Button, Card, Nav, Table } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './cij.css'
import './zartecbutton.css'
import img1 from '../Components/Images/Laser/CO21.png'
import img2 from '../Components/Images/Laser/CO22.png'
import img3 from '../Components/Images/applications/laserco1.png'
import img4 from '../Components/Images/applications/laserco2.png'
import img5 from '../Components/Images/applications/laserco3.png'
import img6 from '../Components/Images/applications/laserco4.png'
import img7 from '../Components/Images/applications/laserco5.png'
import img8 from '../Components/Images/applications/laserco6.png'
import img9 from '../Components/Images/applications/laserco7.png'
import img10 from '../Components/Images/applications/laserco8.png'

function Laserco2() {
    const [activeTab, setActiveTab] = useState('specifications');
    const [activePrinter, setActivePrinter] = useState(null);
    const specsSectionRef = React.useRef(null);

    const specificationData = [
        { label: 'Model', value: 'LT30C' },
        { label: 'Output Power', value: '≥30W' },
        { label: 'Lens', value: 'High precision 2 dimensional scanning system' },
        { label: 'Laser wave length', value: '10.64μm / 10.2μm / 9.3μm' },
        { label: 'Marking speed', value: '≤8000 mm/s' },
        { label: 'Main control system', value: 'Highly integrated mainboard, Embedded 10.4 inch controller' },
        { label: 'Cooling system', value: 'Air cooled' },
        { label: 'Focus zoom lens', value: '130mm double red light focusing' },
        { label: 'Marking scale type', value: 'Raster font, vector font for choosing' },
        { label: 'Min. line width', value: '0.03mm' },
        { label: 'Repeatability accuracy', value: '0.01mm' },
        { label: 'Working area', value: '110X110mm' },
        { label: 'Positioning', value: 'Red light positioning and double red light focusing' },
        { label: 'Lines of marking', value: 'No limited in working area' },
        { label: 'Speed', value: '0~200m/min' },
        { label: 'Power', value: '220VA (110VA can be connected)' },
        { label: 'Power Consumption', value: '500W' }
    ];

    const specificationData1 = [
        { label: 'Model', value: 'LT60C' },
        { label: 'Output Power', value: '≥60W' },
        { label: 'Lens', value: 'High precision 2 dimensional scanning system' },
        { label: 'Laser wave length', value: '10.55 μm-10.6. μm' },
        { label: 'Marking speed', value: '≤8000 mm/s' },
        { label: 'Main control system', value: 'Highly integrated mainboard, Embedded 10.4 inch controller' },
        { label: 'Cooling system', value: 'Air cooled' },
        { label: 'Focus zoom lens', value: '130mm double red light focusing' },
        { label: 'Marking scale type', value: 'Raster font, vector font for choosing' },
        { label: 'Min.line width', value: '0.1mm' },
        { label: 'Repeatability accuracy', value: '0.01mm' },
        { label: 'Working area', value: '100~300mm (range optional)' },
        { label: 'Positioning', value: 'Red light positioning and double red light focusing' },
        { label: 'Lines of marking', value: 'No limited in working area' },
        { label: 'Speed', value: '0~200m/min' },
        { label: 'Power', value: '220VA (110VA can be connected)' },
        { label: 'Power Consumption', value: '500W' }
    ];

    const applicationData=[
        {id:1, image:img3, alt:'Laser coding on paper board packaging'},
        {id:2, image:img4, alt:'Permanent laser marking on PET bottles'},
        {id:3, image:img5, alt:'High-speed laser printing on cardboard'},
        {id:4, image:img6, alt:'Wood engraving with CO₂ laser system'},
        {id:5, image:img7, alt:'Lumber marking for traceability'},
        {id:6, image:img8, alt:'Paper packaging laser coding'},
        {id:7, image:img9, alt:'Plastic container laser marking'},
        {id:8, image:img10, alt:'Glass packaging laser engraving'}
    ];

    const handleProductClick = (printerId) => {
        setActivePrinter(printerId);
        setActiveTab('specifications');

        setTimeout(() => {
            specsSectionRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 50);
    };

    const printers = [
        {
            id: 1,
            model: "ZAR Laser CO₂ - 30W",
            description: "Our 30W CO₂ laser marking machine provides permanent marking solutions for packaging, PET bottles, glass, and various materials. Ideal for barcode laser marking and QR code printing in medium-speed production environments.",
            image: img1,
            specifications: {
                keyFeatures: [
                    {
                        title: "Reliable & High Performance Laser Coding",
                        features: [
                            "Optimized power output for longer lifetime with minimal maintenance",
                            "Clean, eco-friendly operation perfect for food and pharmaceutical packaging",
                            "IP54 rating ensures reliable operation in industrial environments"
                        ]
                    },
                    {
                        title: "High Quality Permanent Marking",
                        features: [
                            "Produces clear, permanent codes for anti-counterfeiting and traceability",
                            "Excellent for laser printing on packaging materials including glass and plastics"
                        ]
                    },
                    {
                        title: "Enhanced Production Efficiency",
                        features: [
                            "Advanced system handles fast message processing up to 200m/min",
                            "Ideal for medium to high-speed production lines in packaging industries"
                        ]
                    },
                    {
                        title: "User-Friendly Operation",
                        features: [
                            "Compact design easily integrates into existing production lines",
                            "10.4 inch touch screen with intuitive interface",
                            "Multi-language support including Arabic and English"
                        ]
                    }
                ],
                technical: specificationData,
                applications: applicationData
            }
        },
        {
            id: 2,
            model: "ZAR Laser CO₂ - 60W",
            description: "The high-power 60W CO₂ laser marking system delivers deeper engraving and faster marking speeds, perfect for demanding applications like glass packaging marking, PET bottle coding, and industrial traceability solutions.",
            image: img2,
            specifications: {
                keyFeatures: [
                    {
                        title: "Industrial-Grade Laser Marking",
                        features: [
                            "High-power 60W output for deeper engraving on tough materials",
                            "Maintenance-free operation with 100,000+ hour lifespan",
                            "IP54 protection for harsh industrial environments"
                        ]
                    },
                    {
                        title: "Precision Marking Solutions",
                        features: [
                            "Crisp, permanent marks for barcodes, QR codes, and product identification",
                            "Excellent for laser coding on glass, plastics, and packaging materials"
                        ]
                    },
                    {
                        title: "High-Speed Production Ready",
                        features: [
                            "Handles line speeds up to 200m/min without compromising quality",
                            "Perfect for high-volume packaging and manufacturing operations"
                        ]
                    },
                    {
                        title: "Simplified Workflow Integration",
                        features: [
                            "Compact footprint fits easily into production lines",
                            "User-friendly 10.4 inch touchscreen interface",
                            "Supports 14 languages for global operations"
                        ]
                    }
                ],
                technical: specificationData1,
                applications: applicationData
            }
        }
    ];

    const renderKeyFeatures = (features) => {
        return features.map((group, index) => (
            <div key={index} style={{ marginBottom: '20px' }}>
                <h5 style={{ color: '#00663b', marginBottom: '10px' }}>{group.title}</h5>
                <ul style={{ listStyle: 'none', paddingLeft: '20px' }}>
                    {group.features.map((feature, i) => (
                        <li key={i} style={{ position: 'relative', paddingLeft: '25px', marginBottom: '8px' }}>
                            <span style={{ 
                                position: 'absolute', 
                                left: 0,
                                color: '#00663b',
                                fontWeight: 'bold',
                                fontSize: '17px',
                            }}>•</span>
                            {feature}
                        </li>
                    ))}
                </ul>
            </div>
        ));
    };

    const renderTabContent = () => {
        if (!activePrinter) return <div className="p-5 text-center">Please select a printer to view details</div>;
        
        const printer = printers.find(p => p.id === activePrinter);
        if (!printer) return null;
        
        switch (activeTab) {
            case 'specifications':
                return (
                    <div style={{ padding: '20px' }}>
                        <h4 style={{ marginTop: '10px', marginBottom: '20px' }}>Key Features</h4>
                        {renderKeyFeatures(printer.specifications.keyFeatures)}
                    </div>
                );
            case 'features':
                return (
                    <div style={{ padding: '20px' }}>
                        <h4 style={{ marginTop: '10px', marginBottom: '20px' }}>Technical Specifications</h4>
                        <Table bordered hover responsive>
                            <tbody>
                                {printer.specifications.technical.map((item, index) => (
                                    <tr key={index}>
                                        <td className="bg-light" style={{ width: '30%', fontWeight: 'bold' }}>{item.label}</td>
                                        <td>{item.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                );
            case 'applications':
                return (
                    <div style={{ padding: '20px' }}>
                        <h4 style={{ marginTop: '10px', marginBottom: '20px' }}>Applications</h4>
                        <div className="row g-4">
                            {printer.specifications.applications.map((app) => (
                            <div key={app.id} className="col-md-6 col-lg-4 pb-5">
                                <div className="card h-100 app-card shadow-sm">
                                <img 
                                    src={app.image} 
                                    className="card-img-top" 
                                    alt={app.alt}
                                    style={{ height: '200px', objectFit: 'cover' }}
                                    loading="lazy"
                                />
                                <div className="card-body">
                                    <h5 className="card-title text-center" style={{fontSize:"15px"}}>{app.alt}</h5>
                                </div>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <Helmet>
                <title>CO₂ Laser Marking Machines | Permanent Coding Solutions for Packaging</title>
                <meta name="description" content="Professional CO₂ laser marking systems for permanent coding on packaging, PET bottles, glass, and more. Features high-speed barcode and QR code marking with 30W and 60W models available." />
                <meta name="keywords" content="laser coding system, permanent marking laser, laser printing for packaging, PET bottle laser marking, glass packaging laser, barcode laser marking, QR code laser printer, CO₂ laser engraver, industrial laser coding" />
                <meta property="og:title" content="Industrial CO₂ Laser Marking Machines | ZAR Laser Systems" />
                <meta property="og:description" content="High-performance laser coding solutions for packaging and manufacturing industries" />
                <link rel="canonical" href="https://www.yourwebsite.com/co2-laser-marking" />
            </Helmet>

            <section>
                <Container className="py-5">
                    <h1 className="mb-4 cijh2">CO<sub>2</sub> Laser Marking Systems</h1>
                    <p className="lead mb-4">Professional laser coding solutions for permanent marking on packaging, glass, plastics, and more. Our CO₂ laser systems provide high-quality, maintenance-free marking for barcodes, QR codes, and product identification.</p>
                    <Row>
                        {printers.map(printer => (
                            <Col lg={4} md={6} className="mb-4" key={printer.id}>
                                <Card 
                                    className={`h-100 border-light shadow-sm rounded-3 ${activePrinter === printer.id ? 'border-primary' : ''}`}
                                    onClick={() => setActivePrinter(printer.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <Card.Body className="d-flex flex-column">
                                        <div className="mb-2" 
                                            style={{
                                                background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                                                WebkitBackgroundClip: "text",
                                                backgroundClip: "text",
                                                color: "transparent",
                                                fontWeight: "bold",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                marginTop: "auto",
                                            }}>
                                            {printer.model}
                                        </div>
                                        <p className="text-muted">{printer.description}</p>
                                        <button 
                                            className="zartec-btn zartec-btn-primary zartec-btn-small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleProductClick(printer.id);
                                            }}
                                        >
                                            View Details
                                        </button>
                                    </Card.Body>
                                    <div className="p-3 text-center">
                                        <img 
                                            src={printer.image} 
                                            alt={`${printer.model} - Industrial laser marking system`} 
                                            className="img-fluid" 
                                            style={{ maxHeight: '200px' }} 
                                            loading="lazy"
                                        />
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
            
            {activePrinter && (
                <section ref={specsSectionRef}>
                    <div className="product-navbar-container mb-4">
                        <Nav className="nav-tabs-custom d-flex justify-content-center">
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'specifications' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('specifications')}
                                >
                                    <span className="nav-text">Key Features</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'features' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('features')}
                                >
                                    <span className="nav-text">Technical Specifications</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'applications' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('applications')}
                                >
                                    <span className="nav-text">Industry Applications</span>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <div className="border border-top-0 p-0 bg-white">
                        {renderTabContent()}
                    </div>
                </section>
            )}
        </div>
    );
}

export default Laserco2;